// Shared upload size limits — keep in sync with backend (server.py).
// No text/word limits on articles.
export const LIMITS = {
  IMAGE_MB: 5,
  VIDEO_MB: 200,
};
